// AdminFreischaltung.js - Version: v1 i30

import React, { useState, useEffect } from "react";
import axios from "axios";
import BackButton from "./BackButton"; // Importiere den Zurück-Button

const AdminFreischaltung = () => {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [tables, setTables] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get("/api/get_clients.php", { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        console.log("✅ API-Antwort für Clients:", response.data);
        if (response.data.success && Array.isArray(response.data.clients)) {
          setClients(response.data.clients);
        } else {
          console.error("❌ Fehler: Clients-Daten ungültig:", response.data);
          setClients([]);
        }
      })
      .catch((error) => console.error("❌ Fehler beim Laden der Klienten:", error));
  }, []);

  useEffect(() => {
    if (selectedClient) {
      const token = localStorage.getItem("token");
      axios
        .get(`/api/get_coaching_tabellen.php?kontakt_id=${selectedClient}`, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => {
          console.log("✅ API-Antwort für Coaching-Tabellen:", response.data);
          if (response.data.success && Array.isArray(response.data.coaching_tabellen)) {
            setTables(response.data.coaching_tabellen);
          } else {
            console.error("❌ Fehler: Tabellen-Daten ungültig:", response.data);
            setTables([]);
          }
        })
        .catch((error) => console.error("❌ Fehler beim Laden der Tabellenfreigaben:", error));
    }
  }, [selectedClient]);

  const updateFreigabe = (table, field, value) => {
    console.log(`🔄 Änderung von ${field} für Tabelle ${table.tabellen_id} auf ${value}`);

    const updatedTables = tables.map((t) =>
      t.tabellen_id === table.tabellen_id ? { ...t, [field]: value } : t
    );
    setTables(updatedTables);

    const token = localStorage.getItem("token");
    axios
      .post(
        "/api/update_freigabe.php",
        {
          kontakt_id: selectedClient,
          tabellen_id: table.tabellen_id,
          sichtbar: field === "sichtbar" ? value : table.sichtbar,
          anderbar: field === "anderbar" ? value : table.anderbar,
          reihenfolge: field === "reihenfolge" ? value : table.reihenfolge,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        console.log(`✅ ${field} für Tabelle geändert:`, response.data);
        if (!response.data.success) {
          console.error(`❌ Fehler beim Aktualisieren von ${field}:`, response.data.message);
        }
      })
      .catch((error) => console.error(`❌ Fehler beim Aktualisieren von ${field}:`, error));
  };

  return (
    <div className="p-4">
      <BackButton to="/admin" /> {/* Zurück-Button zur Admin-Dashboard-Seite */}

      <h2 className="text-xl font-bold mb-4">Admin - Freischaltung</h2>

      <label className="block mb-2 font-semibold">Wähle eine Klientin:</label>
      <select
        onChange={(e) => setSelectedClient(e.target.value)}
        className="p-2 border rounded w-full mb-4"
      >
        <option value="">Bitte auswählen</option>
        {clients.map((client) => (
          <option key={client.id} value={client.id}>
            {client.vorname} ({client.email})
          </option>
        ))}
      </select>

      {selectedClient && (
        <div>
          <h3 className="text-lg font-semibold mb-4">
            Freigegebene Tabellen für {clients.find((c) => c.id.toString() === selectedClient)?.vorname || "Unbekannt"}
          </h3>

          <div className="max-h-48 overflow-y-auto border rounded">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b">
                  <th className="p-2 text-left">Tabellenname</th>
                  <th className="p-2 text-center">Sichtbar</th>
                  <th className="p-2 text-center">Anderbar</th>
                  <th className="p-2 text-center">Reihenfolge</th>
                </tr>
              </thead>
              <tbody>
                {tables.map((table) => (
                  <tr key={table.tabellen_id} className="border-b">
                    <td className="p-2">{table.beschreibung}</td>
                    <td className="p-2 text-center">
                      <input
                        type="checkbox"
                        checked={table.sichtbar === "J"}
                        onChange={() => updateFreigabe(table, "sichtbar", table.sichtbar === "J" ? "N" : "J")}
                      />
                    </td>
                    <td className="p-2 text-center">
                      <input
                        type="checkbox"
                        checked={table.anderbar === "J"}
                        onChange={() => updateFreigabe(table, "anderbar", table.anderbar === "J" ? "N" : "J")}
                      />
                    </td>
                    <td className="p-2 text-center">
                      <input
                        type="number"
                        value={table.reihenfolge}
                        onChange={(e) => updateFreigabe(table, "reihenfolge", parseInt(e.target.value) || 0)}
                        className="w-16 border p-1 text-center"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <BackButton to="/admin" /> {/* Zweiter Zurück-Button unterhalb */}
        </div>
      )}
    </div>
  );
};

export default AdminFreischaltung;